<template> 
  <v-menu
    v-model="statusMenu"
    offset-y
    class="overflow-y"
    max-height="250" 
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="nameSelect"
        dense
        readonly
        outlined
        hide-details="auto"
        :label="$t('label.select-game')"
        v-bind="attrs"
        v-on="on"
      /> 
    </template>
    <v-menu
      v-for="(item, index) in filteredGameTypeItems"
      :key="index" 
      offset-x
      open-on-hover
      close-on-content-click
      class="overflow-y"
      max-height="250"
    > 
      <template v-slot:activator="{ on, attrs }">  
        <v-list 
          dense  
        >
          <v-list-item 
            v-bind="attrs"
            v-on="on"
            @click="selectGame(item,{ id :''})"
          >
            <v-list-item-content>
              {{ item.name }}
            </v-list-item-content>  
            <v-list-item-action>
              <v-icon>
                mdi-menu-right
              </v-icon>
            </v-list-item-action> 
          </v-list-item> 
        </v-list> 
      </template>    
      <v-list 
        v-for="(itemgame, i) in item.games" 
        :key="i"
        dense
      >
        <v-list-item
          @click="selectGame(item,itemgame)" 
        >
          <v-list-item-title>{{ itemgame.name }}</v-list-item-title>
        </v-list-item>
      </v-list>   
    </v-menu>  
  </v-menu> 
</template>

<script>
import { gameType as apiGameType } from '@/apis'
export default {

  props : {
    value:{
      type:Object,
      default : function (){
        return {}
      }
    }, 
    groupTypeId: {
      type: Number,
      default: null
    }
  },

  data: () => ({ 
    statusMenu :'',
    gameTypeItems : []
  }),

  computed : {
    nameSelect () {
      let appendType = this.value.game_name ? `/${this.value.game_name}` : ''
      return this.value.game_type_name ? `${this.value.game_type_name} ${appendType}` : ''
    },
    filteredGameTypeItems () {

      if (this.groupTypeId) {
        return this.gameTypeItems.filter((x) => x.group_game_type_id == this.groupTypeId);
      }

      return this.gameTypeItems;
    }
  },

  async mounted () {  
    await this.getGameType ()
  }, 

  methods : { 
    async getGameType (params = {}) {
      params.scope = 'all'
      const [err,data ] = await apiGameType.get(params)
      
      if(err) {
        this.$alert('',err,'warning') 
        return
      }    
      
      this.gameTypeItems = data
    },

    selectGame (item,itemgame) { 
      this.statusMenu = ! this.statusMenu
      this.$emit('change',item,itemgame)
    }
  }
}
</script>